import moment, { Moment } from 'moment';

class DateTimeConverter {
  /**
   * Returns a moment object from a Date or ISO 8601 string.
   * @param {Date|string} value - A native JavaScript Date or an ISO 8601 date string.
   * @return {Moment} A moment.js date object.
   */
  getMomentDate(value: Date | string): Moment {
    // If value is a js Date object create a moment object without specific formats as it will fail the "strict" parse
    if (this.isJsDate(value)) {
      value = moment(value);
    }

    // Try to parse the text using the given format
    // The last parameter is "strict" so it will not coerce any string into a date
    const date = moment(value, moment.ISO_8601, true);

    return date;
  }

  isJsDate(value: unknown): value is Date {
    return Object.prototype.toString.call(value) === '[object Date]';
  }
}

export default new DateTimeConverter();